module.exports = __webpack_public_path__ + "static/zs2-229f659dbe0fc509592ece6faac3f01a.mp4";